<template>
  <div
    class="payment-simple"
    v-bind:style="{ border: '1px solid #d2d2d2', padding: '10px' }"
  >
    <StripeElements
      :stripe-key="stripeKey"
      :instance-options="instanceOptions"
      :elements-options="elementsOptions"
      #default="{ elements }"
      ref="elms"
    >
      <StripeElement
        type="card"
        :elements="elements"
        :options="cardOptions"
        ref="card"
      />
    </StripeElements>
  </div>
</template>

<script>
import { StripeElements, StripeElement } from "vue-stripe-elements-plus";

export default {
  name: "PaymentSimple",

  components: {
    StripeElements,
    StripeElement
  },

  data() {
    return {
      // pk_test_pedQEITek9p3VreOm4YxjgZ8
      stripeKey: "pk_live_f92H9rnqV23nJk3OkzT2mw7J",
      instanceOptions: {
        locale: this.$i18n.locale
      },
      elementsOptions: {},
      cardOptions: {
        hidePostalCode: true
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/StripeCard.vue